// getShouldNotificationRePopup.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getPopupNotifications from './getPopupNotifications.js';
import getModalData from './getModalData.js';
import getOperationData from './getOperationData.js';
import {
  STATUS_OPENING,
  STATUS_OPENED,
  DETAIL_SELECT_PATH_PREFIX,
} from '../resource/popupNotificationConstants.js';

const defaultList = [];

/**
 * Get should notification re-pop
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} notificationTag - notification tag.
 * @return {Boolean} return true if current notification cover by other notification.
 */
const getShouldNotificationRePopup = createCachedSelector(
  (state, notificationTag) => getModalData(state, [notificationTag], 'zIndex'),
  (state, notificationTag) => {
    const position = getOperationData(
      state,
      [...DETAIL_SELECT_PATH_PREFIX, notificationTag],
      'position'
    );

    return getPopupNotifications(state)
      .filter(notification => {
        const isSamePosition = notification.position === position;
        const isOpen = [STATUS_OPENING, STATUS_OPENED].includes(
          getModalData(state, notification.tag, 'status')
        );
        const isSameNotification = notification.tag === notificationTag;

        if (isSamePosition && isOpen && !isSameNotification) {
          return true;
        }

        return false;
      })
      .map(notification => getModalData(state, notification.tag, 'zIndex'));
  },
  (
    currentNotificationZIndex = 0,
    otherSamePositionNotificationZIndexList = defaultList
  ) => {
    if (otherSamePositionNotificationZIndexList.length === 0) {
      return false;
    }

    const isUnderOtherNotification =
      otherSamePositionNotificationZIndexList.some(
        zIndex => zIndex > currentNotificationZIndex
      );

    return isUnderOtherNotification;
  }
)((state, notificationTag) => notificationTag);

export default getShouldNotificationRePopup;
